import { Link } from 'react-router-dom';

const SERVICES = [
  { label: 'Roof Replacement', href: '/services/roof-replacement' },
  { label: 'Roof Repair', href: '/services/roof-repair' },
  { label: 'Commercial Roofing', href: '/services/commercial' },
  { label: 'Storm Damage', href: '/services/storm-damage' },
  { label: 'Insurance Claims', href: '/services/storm-damage' },
];

const LOCATIONS = [
  { label: 'Salt Lake City', href: '/locations/salt-lake-city' },
  { label: 'West Valley City', href: '/locations/salt-lake-city' },
  { label: 'Provo', href: '/locations/salt-lake-city' },
  { label: 'Ogden', href: '/locations/salt-lake-city' },
  { label: 'Murray', href: '/locations/salt-lake-city' },
];

const COMPANY = [
  { label: 'About Us', href: '/about' },
  { label: 'Our Process', href: '/#process' },
  { label: 'Why Choose Us', href: '/#why-us' },
  { label: 'Testimonials', href: '/#testimonials' },
  { label: 'Free Estimate', href: '/#estimate' },
];

export default function Footer() {
  return (
    <footer className="bg-charcoal-dark text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-5 cursor-pointer">
              <img
                src="https://storage.readdy-site.link/project_files/6c0e61d0-63fd-4d52-9546-5c5e5644f171/5cf4cd26-7f99-44fb-baa6-dacbf1647c05_Intermountain-West-Contractors-west-jordan-utah-cutout.png?v=b85e9b75193f3d9c691bbaaa9462160c"
                alt="IWC Roofing Utah"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-white/60 font-body text-sm leading-relaxed mb-6">
              Utah&apos;s trusted roofing contractor. Residential, commercial, and storm damage restoration with premium materials and expert craftsmanship.
            </p>
            <div className="flex items-center gap-4">
              <a href="tel:+18015550199" className="flex items-center gap-2 text-brand-orange font-body text-sm font-600 cursor-pointer hover:text-brand-orange-light transition-colors">
                <i className="ri-phone-fill"></i>
                (801) 555-0199
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-700 text-brand-orange text-sm uppercase tracking-widest mb-5">Services</h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.label}>
                  <Link to={s.href} className="text-white/60 font-body text-sm hover:text-white transition-colors cursor-pointer">
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="font-heading font-700 text-brand-orange text-sm uppercase tracking-widest mb-5">Locations</h4>
            <ul className="space-y-3">
              {LOCATIONS.map((l) => (
                <li key={l.label}>
                  <Link to={l.href} className="text-white/60 font-body text-sm hover:text-white transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-700 text-brand-orange text-sm uppercase tracking-widest mb-5">Company</h4>
            <ul className="space-y-3">
              {COMPANY.map((c) => (
                <li key={c.label}>
                  <Link to={c.href} className="text-white/60 font-body text-sm hover:text-white transition-colors cursor-pointer">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6 p-4 bg-charcoal rounded-lg">
              <p className="text-white/80 font-body text-xs leading-relaxed">
                <span className="text-brand-orange font-600">Licensed &amp; Insured</span><br />
                Utah Contractor License<br />
                Fully insured for your protection
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 font-body text-xs">
            &copy; 2026 IWC Roofing Utah. All rights reserved.
          </p>
          <p className="text-white/40 font-body text-xs">
            Proudly serving Salt Lake City &amp; Northern Utah
          </p>
        </div>
      </div>
    </footer>
  );
}
